import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { AuthContxt } from './AuthContext';
import step3 from '../../src/Assets/images/f.jpg'


export default function ResetPass() {
  const [errorMsg, seterrorMsg] = useState()
  const [isloading, setisloading] = useState()
  const { UserLoggedIn, setUserLoggedIn } = useContext(AuthContxt)

  const navigate = useNavigate()
  const validationSchema = yup.object({
    email: yup.string().required("Email Field is required").matches(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i, "Enter Valid Email"),
    newPassword: yup.string().required("newPassword Field is required"),

  })



  const { values, handleSubmit, handleChange, errors, touched, handleBlur, isValid } = useFormik({
    initialValues: {
      email: '',
      newPassword: '',

    },
    onSubmit: async () => {
      try {
        setisloading(true)
        let response = await axios.put('https://ecommerce.routemisr.com/api/v1/auth/resetPassword', values)
        console.log(response)

        setUserLoggedIn(true)
        localStorage.setItem('token', response.data.token)

        navigate('/login')



      } catch (error) {
        seterrorMsg(error.response.data.message)

      }
      setisloading(false)
    },

    validationSchema
  })

  return <>
    <div className="container">
    <div className='AuthDiv'>

<div className="w-75 m-auto my-5 authoinner p-xl-5 p-3">
  <div className="row align-items-center">
    <div className="col-md-6">
      <h4>Reset your account password:</h4>
      <form onSubmit={handleSubmit}>

        <label htmlFor="email" className='my-1'>Email:</label>
        <input onChange={handleChange} value={values.email} type="email" className='form-control mb-3' id='email' name='email' />
        {errors.email && touched.email && <p className='alert alert-danger'>{errors.email}</p>}

        <label htmlFor="newPassword" className='my-1'>newPassword:</label>
        <input onChange={handleChange} onBlur={handleBlur} value={values.newPassword} type="Password" className='form-control mb-3' id='newPassword' name='newPassword' />
        {errors.newPassword && touched.newPassword && <p className='alert alert-danger'>{errors.newPassword}</p>}


        {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
        {isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
          :
          <button type='submit' disabled={!isValid || isloading} className='btn bg-main px-3 text-white ms-auto d-block'>Reset</button>
        }

      </form>
    </div>
    <div className="col-md-6">
      <img src={step3} className='w-100' />
    </div>
  </div>

</div>
</div>
    </div>
  </>
}
